<script setup>
import { ref } from 'vue';
import BigModal from '@/components/modal/BigModal.vue';
import { fleetSize, solutions } from '@/components/modal/mocks/registration';

const apiSuccess = ref({
  value: false,
});

function barfPayload(payload) {
  console.log('barfPayload', payload);
  setTimeout(() => {
    apiSuccess.value = {
      value: true,
      message: 'Yowza a success!',
    };
  }, 1000);
}
</script>

<template>
  <h1 class="text-center text-5xl my-6">Temporary home page</h1>
  <big-modal
    :success="apiSuccess"
    title="Register"
    sub-title="Please share some information about your business to allow our
      team to understand how we can help you today to be ready for tomorrow."
    :fleet-size="fleetSize"
    :solutions="solutions"
    show-question
    @validated="barfPayload"
  />
</template>
